import { render, staticRenderFns } from "./WarningPushkinModal.vue?vue&type=template&id=b73e904e&"
import script from "./WarningPushkinModal.vue?vue&type=script&lang=js&"
export * from "./WarningPushkinModal.vue?vue&type=script&lang=js&"
import style0 from "./WarningPushkinModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports